document.addEventListener('DOMContentLoaded', () => {
  if ($('#facebook-posts-show').length > 0) {
    $('body').on('mouseover', "[data-toggle='tooltip']", e => {
      const that = $(this)
      that.tooltip({html: true})
      that.tooltip('show')
    })
  }
})
